export default {
  'form.stepform.basic.title': 'Step form',
  'form.stepform.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'form.stepform.email.required': 'Please enter your email!',
  'form.stepform.email.wrong-format': 'The email address is in the wrong format!',
  'form.stepform.userName.required': 'Please enter your userName!',
  'form.stepform.password.required': 'Please enter your password!',
  'form.stepform.password.twice': 'The passwords entered twice do not match!',
  'form.stepform.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'form.stepform.strength.strong': 'Strength: strong',
  'form.stepform.strength.medium': 'Strength: medium',
  'form.stepform.strength.short': 'Strength: too short',
  'form.stepform.confirm-password.required': 'Please confirm your password!',
  'form.stepform.phone-number.required': 'Please enter your phone number!',
  'form.stepform.phone-number.wrong-format': 'Malformed phone number!',
  'form.stepform.verification-code.required': 'Please enter the verification code!',
  'form.stepform.title.required': 'Please enter a title',
  'form.stepform.date.required': 'Please select the start and end date',
  'form.stepform.goal.required': 'Please enter a description of the goal',
  'form.stepform.standard.required': 'Please enter a metric',

  'form.stepform.form.get-captcha': 'Get Captcha',
  'form.stepform.captcha.second': 'sec',
  'form.stepform.form.optional': ' (optional) ',
  'form.stepform.form.submit': 'Submit',
  'form.stepform.form.save': 'Save',
  'form.stepform.email.placeholder': 'Email',
  'form.stepform.password.placeholder': 'Password',
  'form.stepform.confirm-password.placeholder': 'Confirm password',
  'form.stepform.phone-number.placeholder': 'Phone number',
  'form.stepform.verification-code.placeholder': 'Verification code',
  'form.stepform.title.label': 'Title',
  'form.stepform.title.placeholder': 'Give the target a name',
  'form.stepform.date.label': 'Start and end date',
  'form.stepform.placeholder.start': 'Start date',
  'form.stepform.placeholder.end': 'End date',
  'form.stepform.goal.label': 'Goal description',
  'form.stepform.goal.placeholder': 'Please enter your work goals',
  'form.stepform.standard.label': 'Metrics',
  'form.stepform.standard.placeholder': 'Please enter a metric',
  'form.stepform.client.label': 'Client',
  'form.stepform.label.tooltip': 'Target service object',
  'form.stepform.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'form.stepform.invites.label': 'Inviting critics',
  'form.stepform.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'form.stepform.weight.label': 'Weight',
  'form.stepform.weight.placeholder': 'Please enter weight',
  'form.stepform.public.label': 'Target disclosure',
  'form.stepform.label.help': 'Customers and invitees are shared by default',
  'form.stepform.radio.public': 'Public',
  'form.stepform.radio.partially-public': 'Partially public',
  'form.stepform.radio.private': 'Private',
  'form.stepform.publicUsers.placeholder': 'Open to',
  'form.stepform.option.A': 'Colleague A',
  'form.stepform.option.B': 'Colleague B',
  'form.stepform.option.C': 'Colleague C',
};
